import clsx from "clsx"
import { useNavigate } from "react-router-dom"

import {
  ADMIN_COMPANY_ROUTE,
  ADMIN_RATE_SETTINGS_ROUTE,
  ADMIN_USER_ROUTE,
  BALANCE_ROUTE,
  BASE_RATES,
  CLIENT_COMPANY_ROUTE,
  CLIENT_CONTRACTOR_ROUTE,
  DASHBOARD_ROUTE,
  ORDER_ROUTE,
  PROFILE_ROUTE,
  RATES_ROUTE,
  REPLENISHMENT_ROUTE,
  REQUEST_ROUTE
} from "@/routes"
import { useStore } from "@/stores/RootStoreContext"
import { useCurrencyStore } from "@/stores/currencyStore"

import { type FC } from "react"

import style from "./style.module.scss"
import { useInstancesStore } from "@/stores/instancesStore"
import { useUnreadStore } from "@/stores/unreadStore"
import { IMG } from "@/components/common/CONST"

type Props = {
  isOpen: boolean
  setOpen: (isOpen: boolean) => void
  showPassword: () => void
}

export const BurgerMenu: FC<Props> = ({ isOpen, setOpen, showPassword }) => {
  const navigate = useNavigate()

  const { userStore } = useStore()
  const resetInstances = useInstancesStore(state => state.resetInstances)
  const resetUnreadList = useUnreadStore(state => state.resetUnreadList)
  const currencyDate = useCurrencyStore(state => state.date)
  const currencies = useCurrencyStore(state => state.currencies)

  const isClient = !!userStore.isClient
  const isAdmin = !!userStore.isAdmin
  const isManagerReq = !!userStore.isManagerReq
  const isManagerOrd = !!userStore.isManagerOrd
  const isManagerStmtRead = !!userStore.isManagerStmtRead

  const logout = () => {
    userStore.setToken("")
    window.location.href = "/"
    resetInstances()
    resetUnreadList()
  }

  const handleNavigate = (to: string) => {
    navigate(to)
    setOpen(false)
  }

  const editPassword = () => {
    setOpen(false)
    showPassword()
  }

  return (
    <div className={clsx(style.menuWrapper, { [style.open]: isOpen })}>
      <div className={style.content}>
        <div className={style.menu}>
          {currencies && (
            <div className={clsx("flex-row-10 header-main-currencies", style.currencies)}>
              <li className="main-header-item main-header-item--currency">
                <p className="main-header-item-text">{new Date(currencyDate).toLocaleDateString("ru")}:</p>
              </li>
              <li className="main-header-item main-header-item--currency">
                <p className="main-header-item-text">{`USD ${Number(currencies["USD"]).toFixed(4)}`}</p>
              </li>
            </div>
          )}
          <div onClick={() => handleNavigate(DASHBOARD_ROUTE)}>
            <img src={IMG.home} alt="" className="header-nav-icon" />
            <span>Главная</span>
          </div>
          {!isClient && (
            <div onClick={() => handleNavigate(isClient ? CLIENT_COMPANY_ROUTE : ADMIN_COMPANY_ROUTE)}>
              <img src={IMG.companies} alt="" className="header-nav-icon" />
              <span>Зарубежные компании</span>
            </div>
          )}
          {(isClient || isAdmin) && (
            <div onClick={() => handleNavigate(REQUEST_ROUTE)}>
              <img src={IMG.requests} alt="" className="header-nav-icon" />
              <span>Запросы</span>
            </div>
          )}
          {(isClient || isAdmin) && (
            <div onClick={() => handleNavigate(REPLENISHMENT_ROUTE)}>
              <img src={IMG.deals} alt="" className="header-nav-icon" />
              <span>Пополнения</span>
            </div>
          )}
          {(isClient || isAdmin) && (
            <div onClick={() => handleNavigate(ORDER_ROUTE)}>
              <img src={IMG.orders} alt="" className="header-nav-icon" />
              <span>Ордера</span>
            </div>
          )}
          {isClient && (
            <div onClick={() => handleNavigate(CLIENT_CONTRACTOR_ROUTE)}>
              <img src={IMG.profile} alt="" className="header-nav-icon" />
              <span>Контрагенты</span>
            </div>
          )}
          {isAdmin && (
            <>
              <div onClick={() => handleNavigate(`${ADMIN_USER_ROUTE}?role=ROLE_MANAGER`)}>
                <img src={IMG.profile} alt="" className="header-nav-icon" />
                <span>Менеджеры</span>
              </div>
              <div onClick={() => handleNavigate(`${ADMIN_USER_ROUTE}?role=ROLE_CLIENT`)}>
                <img src={IMG.contr} alt="" className="header-nav-icon" />
                <span>Пользователи</span>
              </div>
            </>
          )}
          {isManagerReq && (
            <>
              <div onClick={() => handleNavigate(REQUEST_ROUTE)}>
                <img src={IMG.requests} alt="" className="header-nav-icon" />
                <span>Запросы</span>
              </div>
              <div onClick={() => handleNavigate(REPLENISHMENT_ROUTE)}>
                <img src={IMG.deals} alt="" className="header-nav-icon" />
                <span>Пополнения</span>
              </div>
            </>
          )}
          {isManagerOrd && (
            <div onClick={() => handleNavigate(ORDER_ROUTE)}>
              <img src={IMG.orders} alt="" className="header-nav-icon" />
              <span>Ордера</span>
            </div>
          )}
          {(isClient || isManagerReq || isManagerOrd) && (
            <div onClick={() => handleNavigate(BASE_RATES)}>
              <img src={IMG.exchange} alt="" className="header-nav-icon" />
              <span>Ставки платформы</span>
            </div>
          )}
          {isAdmin && (
            <div onClick={() => handleNavigate(ADMIN_RATE_SETTINGS_ROUTE)}>
              <img src={IMG.filter_list} alt="" className="header-nav-icon" />
              <span>Настройки системы</span>
            </div>
          )}
          <div onClick={() => handleNavigate(RATES_ROUTE)}>
            <img src={IMG.exchange} alt="" className="header-nav-icon" />
            <span>Курсы валют</span>
          </div>
          {(isManagerStmtRead || isAdmin) && (
            <div onClick={() => handleNavigate(BALANCE_ROUTE)}>
              <img src={IMG.money_bag} alt="" className="header-nav-icon" />
              <span>Балансы</span>
            </div>
          )}
        </div>

        <div className={style.profileMenu}>
          <div onClick={() => handleNavigate(PROFILE_ROUTE)}>Информация</div>
          <div onClick={editPassword}>Пароль</div>
          <div onClick={() => logout()}>Выход</div>
        </div>
      </div>
    </div>
  )
}
